import Vue from "vue";
import Vuex from "vuex";
import VuexPersistenceState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    initForm: {},
    personForm: {},
  },
  mutations: {
    setPersonForm: (state, payload) => {
      state.personForm = payload;
    },
    setInitForm: (state, payload) => {
      state.initForm = payload;
    },
  },
  getters: {
    getPersonForm: (state) => {
      return state.personForm;
    },
    getInitForm: (state) => {
      return state.initForm;
    },
  },
  actions: {},
  plugins: [VuexPersistenceState()],
});
